import { Form, Select, Spin } from 'antd';
import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import InsideHeader from '../../../components/InsideHeader';
import { monthsData, yearsData } from '../../../data';
import { generateP9, generatePayslip } from '../../../features/dropdown/dropdownSlice';
import toast from 'react-hot-toast';

function P9Report() {
    const [form] = Form.useForm();
    const formRef = useRef(null);
    const dispatch = useDispatch(); 
    const {loadingGenerateReport} =  useSelector((state)=>state.dropdown)

    const downloadPayslip = async (data) => {
      const res = await dispatch(
        generateP9({
          year:data?.year, 
        })
      );  
      if (res?.type === "dropdownSlice/generateP9/fulfilled") {
        const isPDF =
          new TextDecoder().decode(res.payload.slice(0, 4)) === "%PDF";
  
        const blob = new Blob([res.payload], {
          type: isPDF ? "application/pdf" : "text/csv",
        });
        const url = window.URL.createObjectURL(blob);
  
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          isPDF ? "generated_report.pdf" : "generated_report.csv"
        );
        document.body.appendChild(link);
        link.click();
  
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        await toast.success("Generated Successfully"); 
        await form.resetFields()
      } else {
        toast.error("Error generating Report");
      }
      
    };
  return (
    <div >
        
         <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={downloadPayslip}
          className="lg:w-[50%] w-full"
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
           <Form.Item
              name="year"
              className=""
              label={<span>Year</span>}
              rules={[
                {
                  required: true,
                  message: "Please select Year",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  yearsData?.length > 0 &&
                  yearsData?.map((item) => ({
                    value: item?.value,
                    label: item?.label,
                  }))
                }
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {}}
                
              />
            </Form.Item>
           

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2"> 
              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={loadingGenerateReport} 
                >
                  {loadingGenerateReport ? <Spin /> : "Generate"}
                </button>
              </div>
            </div>
          </div>
        </Form>
    </div>
  )
}

export default P9Report
